import React, { Component } from 'react';
import { Row, Field, Label }  from '../../generic';
import { ToolTip } from '../../forms/eventFormComponents';
import TextInput from '../../generic/fields/TextInput';
import RadioInput from '../../generic/fields/RadioInput';
import { validRadio } from '../../../helpers/check-required-fields';
import styled from 'styled-components'

const Hint = styled.div`
  color: rgba(0,0,0,0.6);
  margin-bottom: 16px;
  margin-left: 21px;
`

class RSVPOptions extends Component {
  render() {
    const { userEvent, onChange } = this.props
    return (
      <React.Fragment>
        <Row>
          <h2 style={{marginBottom: '20px'}}>RSVP Options</h2>
          <Field name="userEvent[external_rsvp]">
            <Label value="Choose your RSVP method" required={true} style={{marginBottom: '20px'}} />
            <div>
              <RadioInput name="userEvent[external_rsvp]" onChange={onChange} checked={validRadio(userEvent.external_rsvp, false)} value={'false'} label="RSVP via On the Table"/>
              <Hint>Guests will RSVP from your On the Table invitation page. We will email you when people respond. Best for private/small scale events.</Hint>
            </div>
            <div>
              <RadioInput name="userEvent[external_rsvp]" onChange={onChange} checked={validRadio(userEvent.external_rsvp, true)} value={'true'} label="Use another service"/>
              <Hint>Use a service like <a href="https://www.eventbrite.ca" target="_blank">Eventbrite</a> for guests to register. Best for public/larger scale events.</Hint>
            </div>
          </Field>
          {validRadio(userEvent.external_rsvp, true) &&
            <Field name="userEvent[registration_url]" style={{ paddingLeft: '24px' }}>
              <Label value="Guest Registration URL" required={true} />
              <TextInput value={userEvent.registration_url} onChange={onChange} disabled={validRadio(userEvent.external_rsvp, false)} />
            </Field>
          }
        </Row>
      </React.Fragment>
    )
  }
}

export default RSVPOptions
